/* eslint-disable */
import { languageTag } from "../../runtime.js"
import * as en from "../en/pre_registration_closed_body.js"
import * as nl from "../nl/pre_registration_closed_body.js"
import * as de from "../de/pre_registration_closed_body.js"


/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en" | "nl" | "de" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pre_registration_closed_body = (params = {}, options = {}) => {
	return {
		de: de.pre_registration_closed_body,
		en: en.pre_registration_closed_body,
		nl: nl.pre_registration_closed_body
	}[options.languageTag ?? languageTag()]()
}

